module.exports = __webpack_public_path__ + "img/main-1.0526d9dd.jpg";